import { connect } from 'react-redux';

import PageTurner from './PageTurner';

const mapStateToProps = (_, ownProps) => {
  const { count, entriesPerPage, isLoading, page } = ownProps;
  const startNumber = count > 0 ? (page - 1) * entriesPerPage + 1 : 0;
  const endNumber = startNumber + (entriesPerPage - 1) <= count ? startNumber + (entriesPerPage - 1) : count;

  return {
    count,
    endNumber,
    isLoading,
    isOnFirstPage: page === 1,
    isOnLastPage: endNumber === count,
    startNumber,
    ...ownProps,
  };
};

const mapDispatchToProps = (_dispatch, ownProps) => {
  const { changePage, page } = ownProps;
  return {
    viewNextPage: () => changePage(page + 1),
    viewPrevPage: () => changePage(page - 1),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageTurner);
